const vars = {
  env: import.meta.env.VITE_APP_ENV,
  console: (import.meta.env.VITE_APP_ENABLE_CONSOLE === 'true'),
  mocks: {
    locales: (import.meta.env.VITE_APP_ENABLE_MOCKS_LOCALES === 'false'),
    rest: (import.meta.env.VITE_APP_ENABLE_MOCKS === 'true'),
  },
  onlyTranslationMocks: (import.meta.env.VITE_APP_ENABLE_MOCKS_LOCALES === 'true'),
  request: {
    baseUrl: import.meta.env.VITE_APP_REQUEST_BASEURL,
    pdfBaseUrl: import.meta.env.VITE_APP_PDF_REQUEST_BASEURL,
    timeout: parseInt(import.meta.env.VITE_APP_REQUEST_TIMEOUT, 10) || 120000,
    sseUrl: import.meta.env.VITE_APP_SSE_REQUEST,
  },
  inactivity: {
    showSeconds: parseInt(import.meta.env.VITE_APP_INACTIVITY_TILL_SHOW_SECONDS, 10),
    popupCountdownSeconds: parseInt(import.meta.env.VITE_APP_INACTIVITY_COUNTDOWN_SECONDS, 10),
  },
  sentry: {
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  },
};

export default vars;
